import {
    ExistingAccountType,
    GoalsDebtType,
    type MultiSelectOption,
} from '@fruitful/types';

const EXCLUSIVE_OPTION_IDS = new Set<string>([
    GoalsDebtType.NoDebt,
    ExistingAccountType.NoExistingInvestments,
    'no-high-interest-debt',
]);

export const toggleMultiSelectOption = (
    selectedOptionIds: string[],
    optionId: string,
    maxSelections?: number,
): string[] => {
    const isSelected = selectedOptionIds.includes(optionId);

    let next: string[];
    if (isSelected) {
        next = selectedOptionIds.filter((id) => id !== optionId);
    } else if (maxSelections === 1) {
        next = [optionId];
    } else if (
        maxSelections != null &&
        selectedOptionIds.length >= maxSelections
    ) {
        return selectedOptionIds;
    } else {
        next = [...selectedOptionIds, optionId];
    }

    if (EXCLUSIVE_OPTION_IDS.has(optionId)) {
        return [optionId];
    }

    return next.filter((id) => !EXCLUSIVE_OPTION_IDS.has(id));
};

export const formatSelectedLabels = (
    options: readonly MultiSelectOption[],
    selectedOptionIds: readonly string[],
): string =>
    options
        .filter((option) => selectedOptionIds.includes(option.id))
        .map((option) => option.label)
        .join(', ');

export const buildMultiSelectDisplayText = (
    selectedLabels: string,
    customText: string,
): string => {
    const customTrimmed = customText.trim();
    if (selectedLabels === '' && customTrimmed === '') {
        return '';
    }
    if (selectedLabels === '') {
        return customTrimmed;
    }
    if (customTrimmed === '') {
        return selectedLabels;
    }
    return `${selectedLabels}, ${customTrimmed}`;
};
